
import { Routes, Route } from 'react-router-dom';

import Index from './pages/Index';
import ProductSearchPage from './pages/ProductSearchPage';
import NotFound from './pages/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import { AuthProvider } from './contexts/AuthContext';
import { SearchProvider } from './contexts/SearchContext';
import { Toaster } from '@/components/ui/sonner';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <SearchProvider>
        <div className="App">
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/product-search" element={<ProductSearchPage />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Toaster />
        </div>
      </SearchProvider>
    </AuthProvider>
  );
}

export default App;
